import React, { useMemo } from 'react';
import ClipboardTable from 'utility/copyToClipboard/ClipboardTable/ClipboardTable';
import { Column } from 'react-table';

export type PostUrlClipboardTableRow = {
    campaignName: string;
    url: string;
};

type Props = {
    items: PostUrlClipboardTableRow[];
};

const PostUrlClipboardTable = ({ items }: Props) => {
    const columns: Column<PostUrlClipboardTableRow>[] = useMemo(
        () => [
            {
                Header: () => <div>Campaign</div>,
                accessor: 'campaignName',
                Cell: ({ value }) => <div>{value}</div>,
            },
            {
                Header: 'Post URL',
                accessor: 'url',
                Cell: ({ value }) => {
                    return <div>{value}</div>;
                },
            },
        ],
        []
    );

    return <ClipboardTable columns={columns} data={items} />;
};

export { PostUrlClipboardTable };
